// eslint-disable-next-line no-restricted-imports
import { SvgIcon, SvgIconProps } from '@mui/material';
import Svg from '@rhg/../public/_n/images/icons/mind-body-energy.svg';

export const MindBodyEnergy = (props: SvgIconProps) => (
    <SvgIcon component={Svg} inheritViewBox {...props} />
);
